import { getOptionHedgeInput } from './factories';

export const getOptionHedgeAmount = getOptionHedgeInput('amount');
export const getOptionHedgeCurrency = getOptionHedgeInput('currency');
export const getOptionHedgeRate = getOptionHedgeInput('rate');
